<template>
  <div class="digital-content-card">
    <app-image
      :src="image"
      class="app-image"
      fallback="/img/transparent-pixel.png"
      type="square"
    />
    <div class="content">
      <div class="content-title">{{ title }}</div>
      <div class="content-about">{{ about }}</div>
    </div>
    <i class="fa-light fa-arrow-right content-arrow"></i>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'ContentCard',
  props: {
    image: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    about: {
      type: String,
      required: true
    }
  }
});
</script>

<style lang="scss" scoped>
@use '@rready/design/dist/assets/utils.scss';

.digital-content-card {
  display: flex;
  flex-direction: row;
  height: 105px;
  width: 100%;
  min-width: 200px;
  background-color: var(--color-white);
  overflow: hidden;
  border-radius: var(--radius-2);
  box-shadow: 2px 2px 8px 2px rgba(0, 0, 0, 0.05);
  position: relative;

  .app-image {
    flex-basis: 35%;
    max-width: 180px;
    width: 180px;
    height: 100%;
    background-color: var(--color-grey);
  }

  .content {
    flex-basis: 45%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    height: 100%;
    padding: 15px var(--space-4);
  }

  .content-title {
    padding-right: 8px;
    font-weight: 600;
    font-size: 16px;
    color: var(--color-black);
    @include utils.line-clamp(1);
  }

  .content-about {
    padding-right: 14px;
    font-weight: 500;
    font-size: 14px;
    color: var(--color-grey-dark);
    @include utils.line-clamp(2);
  }

  .content-arrow {
    position: absolute;
    bottom: 10px;
    right: 10px;
    color: var(--color-grey-dark);
  }
}
</style>
